// Universal back button used on every page. Minimal text-button style
// chosen for the mobile app, kept consistent on desktop too. Accepts any
// onClick handler — most pages pass either `onBack` (a prop) or an inline
// state-reset callback. The label arg lets callers say "Back to Quotes" etc.;
// defaults to plain "Back".
export default function BackButton({ onClick, label = "Back", style }) {
  return (
    <button
      type="button"
      onClick={onClick}
      style={{
        background: "none",
        border: "none",
        color: "#1a5fb4",
        fontSize: "16px",
        padding: "8px 4px",
        marginBottom: "8px",
        cursor: "pointer",
        ...style,
      }}
    >
      ← {label}
    </button>
  );
}
